module.exports = __webpack_public_path__ + "ring-blueprint-chocolate-ice-cream.0fd642c2531bc38d1be0.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/ring-blueprint-chocolate-ice-cream.svg
// module id = ../../../../../src/assets/img/ring-blueprint-chocolate-ice-cream.svg
// module chunks = main